import { cn } from '@/utils/cn';
import bwipjs from '@bwip-js/browser';
import type { FC } from 'react';

interface QRCodeProps {
  controlNumber: string;
  className?: string;
}

const QRCode: FC<QRCodeProps> = ({ controlNumber, className }) => {
  return (
    <canvas
      ref={(canvas) => {
        if (!canvas) {
          return;
        }
        try {
          bwipjs.toCanvas(canvas, {
            bcid: 'azteccode',
            text: controlNumber,
          });
        } catch (error) {
          console.error('Failed to generate QR code:', error);
        }
      }}
      className={cn(
        'flex h-[144px] w-[144px] items-center justify-center',
        className
      )}
    />
  );
};

export default QRCode;
